<template>
  <div class="cl">
    <header-nav :index_num="index_num"></header-nav>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="350px">
      <span style="font-size:20px">超过系统最大文件容量,无法上传!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="background:#E60012 !important;border:none !important" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <div id="excute_box">
      <!--内容-->
      <div class="excute_con">
        <!-- <h3>
          <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
          一、项目申报书
        </h3>
        <p>
          <a :href="getpros.probook" target="_blank">{{shili? shili.split('_')[0]+''+(shili.split('_')[0].includes('.')?'':'.'+shili.split('.')[1]):"未上传"}}</a>
          <a :href="getpros.probook" target="_blank" v-if="getpros.probook">{{getpros.probook.split('/')[8].split('.')[1] == 'pdf'||getpros.probook.split('/')[8].split('.')[1] == 'jpeg'||getpros.probook.split('/')[8].split('.')[1] == 'png'||getpros.probook.split('/')[8].split('.')[1] == 'jpg'?'预览':'下载'}}</a>
        </p> -->
        <!-- <h3>
          <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
          二、立项批复文件
        </h3>
        <p>
          <a :href="getpros.pifu" target="_blank">{{shili1? shili1:"未上传"}}</a>
          <a :href="getpros.pifu" target="_blank" v-if="getpros.pifu">{{getpros.pifu.split('/')[8].split('.')[1] == 'pdf'||getpros.pifu.split('/')[8].split('.')[1] == 'jpeg'||getpros.pifu.split('/')[8].split('.')[1] == 'png'||getpros.probook.split('/')[8].split('.')[1] == 'jpg'?'预览':'下载'}}</a>
        </p>
        <h3>
          <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
          三、项目合同及实施方案(盖章扫描版)
        </h3>
        <p>
          <a :href="getpros.fangan" target="_blank">{{shili2? shili2:"未上传"}}</a>
          <a :href="getpros.fangan" target="_blank" v-if="getpros.fangan">{{getpros.fangan.split('/')[8].split('.')[1] == 'pdf'||getpros.fangan.split('/')[8].split('.')[1] == 'jpeg'||getpros.fangan.split('/')[8].split('.')[1] == 'png'||getpros.fangan.split('/')[8].split('.')[1] == 'jpg'?'预览':'下载'}}</a>
        </p> -->

        <!-- <div class="mid_box">
          <h3>
            <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
            四、街道（地区办事处）关于2021年社会建设资金购买社会组织服务结项材料的说明
          </h3>
        </div>
        <div class="mid_box">
          <h3>
            <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
            五、项目实施各阶段情况报告
          </h3>

        </div> -->

        <!--tab切换-->
        <!-- <div class="mid_box">
          <h3>
            <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
            六、中期整改报告
          </h3>

        </div>
        <h3>七、末期自评报告</h3>
        <div class="mid_box">
          <h3>
            <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>
            八、项目调整申请及批复（如有请附）
          </h3>

          </div> -->
        <div class="mid_box">
          <div style="display:flex;position:relative">
            <h3>
              <span style="color:red;margin-right:10px;margin-right:3px">*</span>
              一、末期评审档案资料 : (按照政府购买社会组织服务项目末期评审通知中评审档案要求，整理成PDF文档上传)
            </h3>
            <!-- <el-button type="primary" plain class="button_add" @click="add" v-if="status !=1000" v-show="stateing == 2">添加</el-button> -->
          </div>

          <div v-for="(i,j) in ziliaoarr" :key="j" class="activebox">
            <span>项目材料{{j+1}}</span>
            <el-input v-model="name[j]" name="activity" style="width:750px" required class="midsion"></el-input>
            <!-- <el-button type="danger" icon="el-icon-delete" circle style="margin-left:64px" v-if="status !=1000" @click="delactive(j)"></el-button> -->
            <!-- <input type="text" name="activity" value v-model="name[j]" required class="midsion" /> -->
            <div @click="active1(j)">
              <!--  :on-success="handleAvatarSuccess7" -->
              <el-upload class="avatar-uploader activeup" :action="$upload" :show-file-list="false" style="margin-left:3px;position:relative" :http-request="uploadfile10" :disabled="status == 1000" accept=".pdf">

                <!--   -->
                <div style="position: absolute;z-index:9999;width:80px;left:12px;top:42px">
                  <!-- {{uploadname[2]}} -->
                  <!--   -->
                  <el-progress v-if="uploadname[j+10] && uploadname[j+10] != 100" :text-inside="true" :stroke-width="16" :percentage="uploadname[j+10]" status="success"></el-progress>
                </div>
                <img v-if="i!=1&&i" :src="i" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>

              <a class="filename" :href="urls[j]">{{filenamearr[j]?filenamearr[j].lastIndexOf(".")+1>12 ? filenamearr[j].substring(0,12)+"... ."+filenamearr[j].substr(filenamearr[j].lastIndexOf('.')+1):filenamearr[j]:''}}</a>

              <!-- <a class="filename" :href="urls[j]" >{{filenamearr[j]}}</a> -->
              <p class="tip">点击上方图标可上传文件</p>
              <div @click="beforeRemove1('','imageUrl7',j)" class="close" v-if="i.length&&status!=1000" style="left:-9px;top:-65px">
                <i class="el-icon-close close" style="left:140px;top:-107"></i>
              </div>
              <!--文件上传-->
            </div>
          </div>
        </div>
        <div class="mid_box">
          <h3>
            <!-- <span style="color:red;margin-right:10px;position:relative;right:3px">*</span> -->
            <!-- 十、附件1：调研报告（如有请附） -->
          </h3>
          <!-- <el-upload
            class="avatar-uploader"
            :action="$upload"
            :show-file-list="false"
            style="position: relative"
            :http-request="uploadfile7"
           :disabled="getpros.over.status == 1000"
          >
            <div style="position: absolute;z-index:9999;width:80px;left:12px;top:42px">

              <el-progress
                v-if="uploadname[6] && uploadname[6] != 100"
                :text-inside="true"
                :stroke-width="16"
                :percentage="uploadname[6]"
                status="success"
              ></el-progress>
            </div>
            <img v-if="imageUrl8" :src="imageUrl8" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <a
            class="filename"
            :href="fileurl8"
          >{{filename8? filename8.split('_')[0]+''+(filename8.split('_')[0].includes('.')?'':'.'+filename8.split('.')[1]):""}}</a>
          <p class="tip">点击上方图标可上传文件</p>
          <div @click="beforeRemove1(filename8,'imageUrl8')" class="close" v-if="imageUrl8&&getpros.over.status!=1000">
            <i class="el-icon-close close"></i>
          </div> -->
          <!--文件上传-->
        </div>
        <div class="mid_box">
          <h3>
            <!-- <span style="color:red;margin-right:10px;position:relative;right:3px">*</span> -->
            <!-- 十一、附件2：满意度分析报告（如有请附） -->
          </h3>
        </div>
        <!-- <div class="mid_box">
          <h3>
            <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>十、财务管理制度
          </h3>
          <el-upload
            class="avatar-uploader"
            :action="$upload"
            :show-file-list="false"
            style="position: relative"
            :http-request="uploadfile8"
            :disabled="getpros.over.status == 1000"
          >
            <div style="position: absolute;z-index:9999;width:80px;left:12px;top:42px">
              <el-progress
                v-if="uploadname[7] && uploadname[7] != 100"
                :text-inside="true"
                :stroke-width="16"
                :percentage="uploadname[7]"
                status="success"
              ></el-progress>
            </div>
            <img v-if="imageUrl9" :src="imageUrl9" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <a
            class="filename"
            :href="fileurl9"
          >{{filename9? filename9.split('_')[0]+''+(filename9.split('_')[0].includes('.')?'':'.'+filename9.split('.')[1]):""}}</a>
          <p class="tip">点击上方图标可上传文件</p>
          <div @click="beforeRemove1(filename9,'imageUrl9')" class="close" v-if="imageUrl9&&getpros.over.status!=1000">
            <i class="el-icon-close close"></i>
          </div>
        </div> -->


        <!-- <div class="mid_box">
          <h3>
            <span style="color:red;margin-right:10px;position:relative;right:3px">*</span>十一、项目经费、预算决算表
          </h3>
          <el-upload
            class="avatar-uploader"
            :action="$upload"
            :show-file-list="false"
            style="position: relative"
            :http-request="uploadfile9"
            :disabled="getpros.over.status == 1000"
          >
            <div style="position: absolute;z-index:9999;width:80px;left:12px;top:42px">
              <el-progress
                v-if="uploadname[8] && uploadname[8] != 100"
                :text-inside="true"
                :stroke-width="16"
                :percentage="uploadname[8]"
                status="success"
              ></el-progress>
            </div>
            <img v-if="imageUrl10" :src="imageUrl10" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <a
            class="filename"
            :href="fileurl10"
          >{{filename10? filename10.split('_')[0]+''+(filename10.split('_')[0].includes('.')?'':'.'+filename10.split('.')[1]):""}}</a>
          <p class="tip">点击上方图标可上传文件</p>
          <div @click="beforeRemove1(filename10,'imageUrl10')" class="close" v-if="imageUrl10&&getpros.over.status!=1000">
            <i class="el-icon-close close"></i>
          </div>
        </div> -->
        <div class="mid_box">
          <h3>
            二、末期PPT文件上传
          </h3>
          <!-- :disabled="status == 1000"-->
          <el-upload class="avatar-uploader" :action="$upload" :show-file-list="false" style="position: relative"
          :http-request="uploadfile5"  accept=".ppt">
            <div style="position: absolute;z-index:9999;width:80px;left:14px;top:42px;">
              <el-progress v-if="uploadname[5] && uploadname[5] != 100" :text-inside="true" :stroke-width="16" :percentage="uploadname[5]" status="success"></el-progress>
            </div>
            <img v-if="imageUrl6" :src="imageUrl6" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <a class="filename" :href="fileurl6">{{filename6? filename6:""}}</a>
          <p class="tip">点击上方图标可上传文件</p>
          <div @click="beforeRemove1(filename6,'imageUrl6')" v-if="imageUrl6 && status != 1">
            <i class="el-icon-close close2"></i>
          </div>
        </div>
        <div class="ll"  v-if="status!=1000">
          <el-form ref="numberValidateForm" label-width="100px" class="demo-ruleForm">
            <el-form-item>
              <button type="button" @click="before" style="cursor:pointer">返回</button>
              <button type="button" @click="postEnd(0)" style="cursor:pointer">保存</button>
              <button type="button" @click="postEnd(1)" class="tj" style="cursor:pointer">提交</button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footer-nav class="footer"></footer-nav>
  </div>
</template>
<script>
  const path = require("path");
  const files = require.context("@/components", false, /\.vue$/);
  const modules = {};
  files.keys().forEach(key => {
    const name = path.basename(key, ".vue");
    modules[name] = files(key).default || files(key);
  });
  var preD = function (e) {
    e.preventDefault();
  };
  export default {
    // eslint-disable-next-line no-undef
    components: modules,
    props: {},
    data() {
      return {
        status: '',
        stateing: 2,
        uploadname: ["", "", "", "", "", "", "", "", "", ""],
        uploadno: "",
        uploadfun: "",
        convers: ["1", "2", "3", "4", "5", "6"],
        index_num: 2,
        sub: 0,
        subMidText: "",
        subMidVal: "",
        stateText: "",
        stateVal: "",
        activeText: "",
        activeVal: "",
        targetText: "",
        targetVal: "",
        proactText: "",
        proactVal: "",
        greatText: "",
        greatVal: "",
        mediaText: "",
        mediaVal: "",
        sumupText: "",
        sumupVal: "",
        name: "",
        imageUrl: "",
        imageUrl1: "",
        imageUrl2: "",
        imageUrl3: "",
        imageUrl4: "",
        imageUrl5: "",
        imageUrl6: "",
        imageUrl7: [],
        imageUrl8: "",
        imageUrl9: "",
        imageUrl10: "",
        num: 0,
        share: "",
        company: "",
        activity: "",
        numberValidateForm: "",
        over: null,
        getpros: {},
        subStatus: 0,
        project_id: 83,
        explain: "",
        location: "",
        job_mon: "",
        assess: "",
        people: "",
        develop: "",
        pro_condition: "",
        result: "",
        summary: "",
        fina: "",
        elereport: "",
        adjust: "",
        ziliao: "",
        pro_result: "",
        manage: "",
        money: "",
        dialogTableVisible: false,
        dialogFormVisible: false,
        zData: [],
        month: "",
        fileid: "",
        filename: "",
        filename1: "",
        filename2: "",
        filename3: "",
        filename4: "",
        filename5: "",
        filename6: "",
        filename7: "",
        filename8: "",
        filename9: "",
        filename10: "",
        fileurl: "",
        fileurl1: "",
        fileurl2: "",
        fileurl3: "",
        fileurl4: "",
        fileurl5: "",
        fileurl6: "",
        fileurl7: "",
        fileurl8: "",
        fileurl9: "",
        fileurl10: "",
        fileLists: [],
        shili: "",
        shili1: "",
        shili2: "",
        shili3: "",
        shili4: "",
        visitDate: [],
        ziliaoarr: [1],
        ziliaofile: [],
        fileurl7: [],
        name: [],
        urls: [],
        chooseurl: [],
        urlno: 0,
        filetype: [],
        people: "",
        filenamearr: [],
        dialogVisible: false
      };
    },
    computed: {},

    watch: {
      ziliaoarr() {
        for (let i in this.ziliaoarr) {
          // this.urls[i] = "";
          // this.imageUrl7[i] = "";
          // this.filetype[i]=""
        }
      },
      popupStatus(val) {
        if (val) {
          document.body.style.overflow = "hidden";
          document.addEventListener("touchmove", preD, {
            passive: false
          }); /** 禁止页面滑动 */
        } else {
          document.body.style.overflow = ""; /** 出现滚动条 */
          document.removeEventListener("touchmove", preD, {
            passive: false
          });
        }
      }
    },

    methods: {
      toclose() {
        this.month = ''
        this.fileLists = []

      },
      uploadfile(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                0,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }


            }
          })
          .then(res => {

            if (this.uploadname[0] === 100) {

              this.handleAvatarSuccess(res.data.data, f.file.name);

            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      //  四 街道 e结项项目材料说明

      uploadfile1(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                1,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[1] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess1(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      // 项目实施各阶段情况报告

      uploadfile1(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)

              this.$set(
                this.uploadname,
                1,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {

            if (this.uploadname[1] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess1(res.data.data, f.file.name);

            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      // 中期电子报告

      uploadfile2(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                2,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[2] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess2(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      // 项目财务报告

      uploadfile3(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)

              this.$set(
                this.uploadname,
                3,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[3] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess4(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      // 财务报告

      uploadfile4(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                4,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[4] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess5(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      // 其他类

      uploadfile5(f) {
        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              this.$set(
                this.uploadname,
                5,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            if (this.uploadname[5] === 100) {
              this.handleAvatarSuccess6(res.data.data, f.file.name);
            }
          })
          .catch(error => {
            // console.log(error);(error);
          });
        return;
      },
      // ppt

      uploadfile6(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                this.urlno + 7,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[this.urlno + 7] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess7(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },
      uploadfile7(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                6,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[6] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess8(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },

      uploadfile8(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                7,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }
            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[7] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess9(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },

      uploadfile9(f) {

        let formdata = new FormData();
        formdata.append("file", f.file);
        this.$axios({
            url: "v1/file/files",
            method: "post",
            data: formdata,
            nol: 45,
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
              // progressEvent.loaded:已上传文件大小
              // progressEvent.total:被上传文件的总大小

              // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


              this.$set(
                this.uploadname,
                8,
                parseInt((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (progressEvent.loaded > 307200000) {
                this.dialogVisible = true;
                return false;
              }

            }
          })
          .then(res => {
            // this.imageUrl = res.data.data
            if (this.uploadname[8] === 100) {
              // this.progressPercent = 0
              this.handleAvatarSuccess10(res.data.data, f.file.name);
              // this.uploadfun.fun(res.data.data, f.file.name);
            }
          })
          .then(error => {
            // console.log(error);(error);
          });
        return;
      },

      uploadfile10(f) {

        let fileName = f.file.name;
        let uid = f.file.uid
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);

        if (lastName.toLowerCase() == ".pdf") {
          let formdata = new FormData();
          formdata.append("file", f.file);
          this.$axios({
              url: "v1/file/files",
              method: "post",
              data: formdata,
              nol: 45,
              headers: {
                "Content-Type": "multipart/form-data"
              },
              onUploadProgress: progressEvent => {
                // progressEvent.loaded:已上传文件大小
                // progressEvent.total:被上传文件的总大小

                // this.uploadname =  parseInt(progressEvent.loaded / progressEvent.total * 100)


                this.$set(
                  this.uploadname,
                  this.urlno + 10,
                  parseInt((progressEvent.loaded / progressEvent.total) * 100)
                );
                if (progressEvent.loaded > 307200000) {
                  this.dialogVisible = true;
                  return false;
                }

              }
            })
            .then(res => {
              // this.imageUrl = res.data.data
              if (this.uploadname[this.urlno + 10] === 100) {
                // this.progressPercent = 0
                this.handleAvatarSuccess7(res.data.data, f.file.name);
                // this.uploadfun.fun(res.data.data, f.file.name);
              }
            })
            .then(error => {
              // console.log(error);(error);
            });
          return;
        } else {
          this.$message.error("文件必须为pdf 类型");
        }
      },
      delactive(e) {

        this.ziliaoarr.splice(e, 1);

        this.name.splice(e, 1);
        if (this.ziliaoarr.length < 2) {
          this.stateing = 2
        }

      },
      removefile() {

      },
      before() {
        this.$jParams("schedule", {
          id: this.id,
          mid_sub: 1
        });
        // this.$jParams("schedule", { id: this.id });
      },
      inform(data) {
        this.getpros.prodemofg = data;
      },
      add() {

        this.ziliaoarr.push(1);

        if (this.ziliaoarr.length > 1) {
          this.stateing = 1
        }
        this.name.push("");
        this.uploadname.push("");
      },
      active1(m) {

        this.chooseurl.push(m);
        this.urlno = m;

      },
      getTime() {},
      successUploadThree(response, file, fileList) {
        this.fileid = file.response.data.id;
        this.filename = file.response.data.name;
        this.fileurl = file.response.data.url;

      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 10 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
        );
      },
      beforeRemove1(e, f, g) {

        if (e.length) {
          this.$confirm(`删除文件后将无法恢复，请谨慎操作?`).then(() => {
            // this.handleRemove1()

            switch (f) {
              case "imageUrl":
                this.imageUrl = "";
                this.filename = "";
                this.fileurl = "";
                break;
              case "imageUrl1":
                this.imageUrl1 = "";
                this.filename1 = "";
                this.fileurl1 = "";
                break;
              case "imageUrl2":
                this.imageUrl2 = "";
                this.filename2 = "";
                this.fileurl2 = "";
                break;
              case "imageUrl3":
                this.imageUrl3 = "";
                this.filename3 = "";
                this.fileurl3 = "";
                break;
              case "imageUrl4":
                this.imageUrl4 = "";
                this.filename4 = "";
                this.fileurl4 = "";
                break;
              case "imageUrl5":
                this.imageUrl5 = "";
                this.filename5 = "";
                this.fileurl5 = "";
                break;
              case "imageUrl6":
                this.imageUrl6 = "";
                this.filename6 = "";
                this.fileurl6 = "";
                break;
              case "imageUrl7":
                this.imageUrl7 = "";
                this.filename7 = "";
                this.fileurl7 = "";
                break;
              case "imageUrl8":
                this.imageUrl8 = "";
                this.filename8 = "";
                this.fileurl8 = "";
                break;
              case "imageUrl9":
                this.imageUrl9 = "";
                this.filename9 = "";
                this.fileurl9 = "";
                break;
              case "imageUrl10":
                this.imageUrl10 = "";
                this.filename10 = "";
                this.fileurl10 = "";
                break;
              default:
                break;
            }


          });
        } else {
          this.$confirm(`删除文件后将无法恢复，请谨慎操作`).then(() => {
            // this.handleRemove1()
            switch (f) {
              case "imageUrl7":

                this.imageUrl7[g] = "";
                this.ziliaoarr[g] = "";
                this.filetype[g] = "";
                this.urls[g] = "";
                this.filenamearr[g] = "";
                for (let i in this.filetype) {

                  if (this.filetype[i] == "docx" || this.filetype[i] == "doc") {
                    this.imageUrl7[i] = require("../../../static/img/word.png");
                  } else if (
                    this.filetype[i] == "pptx" ||
                    this.filetype[i] == "ppt"
                  ) {
                    this.imageUrl7[i] = require("../../../static/img/ppt.png");
                  } else if (this.filetype[i] == "pdf") {
                    this.imageUrl7[i] = require("../../../static/img/pdf.jpg");
                  } else if (
                    this.filetype[i] == "xls" ||
                    this.filetype[i] == "xlsx"
                  ) {
                    this.imageUrl7[i] = require("../../../static/img/excel.png");
                  } else if (
                    this.filetype[i] == "jpg" ||
                    this.filetype[i] == "jpeg" ||
                    this.filetype[i] == "png"
                  ) {
                    this.imageUrl7[this.urlno] = file.response.data.url;
                    // this.imageUrl7[i] = file.response.data.url;
                  }
                }

                for (let i in this.ziliaoarr) {
                  for (let m in this.imageUrl7) {
                    if (m == i) {
                      this.$set(this.ziliaoarr, i, this.imageUrl7[m]);
                      // this.ziliaoarr[i]=this.imageUrl3[m]
                    }
                  }
                }
                break;
              default:
                break;
            }

          });
        }

        return;
      },
      handleRemove1() {},
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name} ?`);
      },
      successUploadTwo(response, file, fileList) {
        this.fileid = file.response.data.id;
        this.filename = file.response.data.name;
        this.fileurl = file.response.data.url;
        this.fileLists.push(file.response.data)


      },
      handlePreview(file) {

        this.previewinfo = file;
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          alert("推荐谷歌进行文件预览");
        } else {
          window.open(file.url); //blob格式地址
        }
      },
      handleRemove(file, fileList) {

        this.fileLists.forEach(element => {

          if (file.name === element.name) {


            this.fileLists.splice(this.fileLists.lastIndexOf(element), 1);
          }
        });

        return;
      },
      subBtn() {

        var strtime = "2014-04-23 18:55:49:123";
        // 可以这样做

        if (this.fileLists.length) {
          if (this.month) {
            this.$http({
                method: "post",
                url: "v1/pro/mon",
                data: {
                  project_id: this.id,
                  month: Math.round(this.month / 1000),
                  pid: this.fileLists[0].id,
                  name: this.fileLists[0].name,
                  elereport: JSON.stringify(this.fileLists),
                }
              })
              .then(res => {
                if (res.data.data.code === 200) {

                  this.dialogTableVisible = false;
                  this.month = "";
                  this.getPro();
                  this.$message({
                    type: "success",
                    message: "操作成功"
                  });
                  this.fileLists = []
                } else {
                  alert("请求失败！");
                }
              })
              .catch(err => {
                // console.log(error);(err);
              });
          } else {
            this.$message({
              type: "error",
              message: "请选择日期"
            });
          }
        } else {
          this.$message({
            type: "error",
            message: "请先上传电子版文件"
          });
        }
      },
      subsBun() {
        var date = new Date(this.month.replace(/-/g, "/"));
        var datefin = Math.round(date.getTime() / 1000).toString();
        this.$http({
            method: "post",
            url: "v1/pro/news",
            data: {
              project_id: this.id,
              month: datefin,
              pid: this.fileid,
              name: this.filename,
              elereport: this.fileurl
            }
          })
          .then(res => {
            if (res.data.data.code === 200) {

              this.dialogFormVisible = false;
              this.getPostData();
            } else {
              alert("请求失败！");
            }
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      subMid(data) {
        this.subMidVal = data;
      },
      state(data) {
        this.stateVal = data;
      },
      active(data) {
        this.activeText = data;
      },
      target(data) {
        this.targetText = data;
      },
      proact(data) {
        this.proactVal = data;
      },
      great(data) {
        this.greatText = data;
      },
      media(data) {
        this.mediaText = data;
      },
      sumup(data) {
        this.sumupVal = data;
      },
      aterm() {},
      fterm() {},
      handleAvatarSuccess(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl = res.url;

        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl = require("../../../static/img/txt.jpg");
        }
        this.filename = res.name; // res.name + "." + res.extension;

      },
      handleAvatarSuccess1(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl1 = res.url;

        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl1 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl1 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl1 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl1 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl1 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl1 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl1 = require("../../../static/img/txt.jpg");
        }
        this.filename1 = res.name; // res.name + "." + res.extension;

      },
      handleAvatarSuccess2(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl2 = res.url;

        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl2 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl2 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl2 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl2 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl2 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl2 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl2 = require("../../../static/img/txt.jpg");
        }
        this.filename2 = res.name; // res.name + "." + res.extension;


      },
      handleAvatarSuccess3(res, file) {

        this.fileurl3 = file.response.data.url;
        // this.imageUrl3 = "/index/timg.jpg";
        if (
          file.response.data.extension == "docx" ||
          file.response.data.extension == "doc"
        ) {
          this.imageUrl3 = require("../../../static/img/word.png");
        } else if (
          file.response.data.extension == "pptx" ||
          file.response.data.extension == "ppt"
        ) {
          this.imageUrl3 = require("../../../static/img/ppt.png");
        } else if (file.response.data.extension == "pdf") {
          this.imageUrl3 = require("../../../static/img/pdf.jpg");
        } else if (
          file.response.data.extension == "xls" ||
          file.response.data.extension == "xlsx"
        ) {
          this.imageUrl3 = require("../../../static/img/excel.png");
        } else if (
          file.response.data.extension == "jpg" ||
          file.response.data.extension == "jpeg" ||
          file.response.data.extension == "png"
        ) {
          this.imageUrl3 = file.response.data.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl3 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl3 = require("../../../static/img/txt.jpg");
        }
        this.filename3 = file.response.data.name;

      },
      handleAvatarSuccess4(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl4 = res.url;

        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl4 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl4 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl4 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl4 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl4 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl4 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl4 = require("../../../static/img/txt.jpg");
        }
        this.filename4 = res.name; // res.name + "." + res.extension;

      },
      handleAvatarSuccess5(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl5 = res.url;
        // this.imageUrl2 = file.response.data.url;
        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl5 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl5 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl5 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl5 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl5 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl5 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl5 = require("../../../static/img/txt.jpg");
        }
        this.filename5 = res.name; //res.name + "." + res.extension;

      },
      handleAvatarSuccess6(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];
        this.fileurl6 = res.url;
        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl6 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl6 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl6 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl6 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl6 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl6 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl6 = require("../../../static/img/txt.jpg");
        }
        this.filename6 = res.name; //res.name + "." + res.extension;

      },
      handleAvatarSuccess7(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        // this.fileurl = res.url;
        this.chooseurl = Array.from(new Set(this.chooseurl));
        this.filetype[this.urlno] = houzui;
        this.urls[this.urlno] = res.url;
        this.$set(this.filenamearr, this.urlno, res.names + "." + res.extension);
        // this.filenamearr[this.urlno] = res.name;
        for (let i in this.filetype) {

          if (this.filetype[i] == "docx" || this.filetype[i] == "doc") {
            this.$set(this.imageUrl7, i, require("../../../static/img/word.png"));
            // this.imageUrl7[i] = "/static/img/word.png";
          } else if (this.filetype[i] == "pptx" || this.filetype[i] == "ppt") {
            // this.imageUrl7[i] = "/static/img/ppt.png";
            this.$set(this.imageUrl7, i, require("../../../static/img/ppt.png"));
          } else if (this.filetype[i] == "pdf") {
            // this.imageUrl7[i] = "/static/img/pdf.jpg";
            this.$set(this.imageUrl7, i, require("../../../static/img/pdf.jpg"));
          } else if (this.filetype[i] == "txt") {
            this.$set(this.imageUrl7, i, require("../../../static/img/txt.png"));
          } else if (this.filetype[i] == "xls" || this.filetype[i] == "xlsx") {
            // this.imageUrl7[i] = "/static/img/excel.png";
            this.$set(this.imageUrl7, i, require("../../../static/img/excel.png"));
          } else if (
            this.filetype[i] == "jpg" ||
            this.filetype[i] == "jpeg" ||
            this.filetype[i] == "png"
          ) {
            // this.imageUrl7[this.urlno] = file
            this.$set(this.imageUrl7, this.urlno, res.url);
            // this.imageUrl3=this.urls
          } else if (this.filetype[i] == "zip" || this.filetype[i] == "rar") {
            //  this.imageUrl7 = "/static/img/zip.png";
            this.$set(this.imageUrl7, i, require("../../../static/img/zip.png"));
          }
        }

        for (let i in this.ziliaoarr) {
          for (let m in this.imageUrl7) {
            if (m == i) {
              this.$set(this.ziliaoarr, i, this.imageUrl7[m]);
              // this.ziliaoarr[i]=this.imageUrl3[m]
            }
          }
        }

      },
      handleAvatarSuccess8(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl8 = res.url;
        // this.imageUrl2 = file.response.data.url;
        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl8 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl8 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl8 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl8 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl8 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl8 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl8 = require("../../../static/img/txt.jpg");
        }
        this.filename8 = res.name; // res.name + "." + res.extension;


      },
      handleAvatarSuccess9(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl9 = res.url;
        // this.imageUrl2 = file.response.data.url;
        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl9 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl9 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl9 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl9 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl9 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl9 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl9 = require("../../../static/img/txt.jpg");
        }
        this.filename9 = res.name; // res.name + "." + res.extension;

      },
      handleAvatarSuccess10(res, file) {
        let houzui = file.split(".");
        houzui = houzui[houzui.length - 1];

        this.fileurl10 = res.url;
        // this.imageUrl2 = file.response.data.url;
        if (houzui == "doc" || houzui == "docx") {
          this.imageUrl10 = require("../../../static/img/word.png");
        } else if (houzui == "pptx" || houzui == "ppt") {
          this.imageUrl10 = require("../../../static/img/ppt.png");
        } else if (houzui == "pdf") {
          this.imageUrl10 = require("../../../static/img/pdf.jpg");
        } else if (houzui == "xls" || houzui == "xlsx") {
          this.imageUrl10 = require("../../../static/img/excel.png");
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this.imageUrl10 = res.url;
        } else if (houzui == "zip" || houzui == "rar") {
          this.imageUrl10 = require("../../../static/img/zip.png");
        } else if (houzui == "txt") {
          this.imageUrl = require("../../../static/img/txt.jpg");
        }
        this.filename10 = res.name; //res.name + "." + res.extension;

      },

      beforeAvatarUpload(file) {

      },
      submitForm(formName) {

        alert("保存成功");
      },
      resetForm(formName) {

        alert("提交成功");
      },
      getPro() {
        this.$http({
            method: "get",
            url: "v1/test/cent-data",
            params: {
              id: this.id
            }
          })
          .then(res => {
            if (res.data.data.code == 0) {
              alert(res.data.data.message);
              this.$router.push({
                path: "schedule" + this.id
              });
            } else {
              this.c = res.data.data;
              this.getpros = res.data.data;
              this.status = this.getpros.over.status;
              var _this = this
              let shili = res.data.data.probook;
              this.shili = shili.substring(shili.lastIndexOf("/") + 1);
              _this.hz = _this.shili.lastIndexOf(".") + 1;
              if (_this.hz > 13) {
                _this.shili = _this.shili.substr(0, 12) + "... ." + shili.substring(shili.lastIndexOf(".") + 1)
              }

              let shili1 = res.data.data.pifu;
              if (shili1) {
                _this.shili1 = shili1.substring(shili1.lastIndexOf("/") + 1);
                _this.hz = _this.shili1.lastIndexOf(".") + 1;
                if (_this.hz > 13) {
                  _this.shili1 = _this.shili1.substr(0, 12) + "... ." + shili1.substring(shili1.lastIndexOf(".") + 1)
                }

              }

              let shili2 = res.data.data.fangan;
              if (shili2) {
                _this.shili2 = shili2.substring(shili2.lastIndexOf("/") + 1);
                _this.hz = _this.shili2.lastIndexOf(".") + 1;
                if (_this.hz > 13) {
                  _this.shili2 = _this.shili2.substr(0, 12) + "... ." + shili2.substring(shili2.lastIndexOf(".") + 1)
                }

              }

              let shili3 = res.data.data.probook;
              if (shili3) {
                this.shili3 = shili.substring(shili.lastIndexOf("/") + 1);
              }


              let shili4 = res.data.data.probook;
              if (shili4) {
                this.shili4 = shili.substring(shili.lastIndexOf("/") + 1);
              }

              this.$set(this, "visitDate", [
                res.data.data.aterm,
                res.data.data.fterm
              ]);
              this.getpros.prodemofg = '';
              // 获取PPT
              if (res.data.data.over.ppt) {
                this.fileloading(res.data.data.over.ppt, 'filename6', 'imageUrl6', 'fileurl6');
              }
              if (res.data.data.over.people) {
                this.getpros.prodemofg = res.data.data.over.people;
                if (res.data.data.over.explain) {
                  this.fileloading(
                    res.data.data.over.explain,
                    "filename",
                    "imageUrl",
                    "fileurl"
                  );
                }
                if (res.data.data.over.location) {
                  this.fileloading(
                    res.data.data.over.location,
                    "filename1",
                    "imageUrl1",
                    "fileurl1"
                  );
                }
                if (res.data.data.over.assess) {
                  this.fileloading(
                    res.data.data.over.assess,
                    "filename2",
                    "imageUrl2",
                    "fileurl2"
                  );
                }
                if (res.data.data.over.fina) {
                  this.fileloading(
                    res.data.data.over.fina,
                    "filename4",
                    "imageUrl4",
                    "fileurl4"
                  );
                }
                if (res.data.data.over.elereport) {
                  this.fileloading(
                    res.data.data.over.elereport,
                    "filename5",
                    "imageUrl5",
                    "fileurl5"
                  );
                }
                if (res.data.data.over.adjust) {
                  this.fileloading(
                    res.data.data.over.adjust,
                    "filename6",
                    "imageUrl6",
                    "fileurl6"
                  );
                }
                if (res.data.data.over.pro_result) {
                  this.fileloading(
                    res.data.data.over.pro_result,
                    "filename8",
                    "imageUrl8",
                    "fileurl8"
                  );
                }
                if (res.data.data.over.manage) {
                  this.fileloading(
                    res.data.data.over.manage,
                    "filename9",
                    "imageUrl9",
                    "fileurl9"
                  );
                }

                if (res.data.data.over.money) {
                  this.fileloading(
                    res.data.data.over.money,
                    "filename10",
                    "imageUrl10",
                    "fileurl10"
                  );
                }
                if (res.data.data.over.develop) {
                  this.subMidVal = res.data.data.over.develop;
                }
                if (res.data.data.over.pro_condition) {
                  this.stateVal = res.data.data.over.pro_condition;
                }
                if (res.data.data.over.result) {
                  this.proactVal = res.data.data.over.result;
                }
                if (res.data.data.over.summary) {
                  this.sumupVal = res.data.data.over.summary;
                }
                let arrlist = JSON.parse(res.data.data.over.ziliao)
                if (arrlist.length) {
                  this.ziliaoarr = []
                  for (let i in arrlist) {
                    let url = arrlist[i].elereport;
                    this.name[i] = arrlist[i].name;
                    this.urls[i] = arrlist[i].elereport;
                    // this.$set(this.name,i,arrlist[i].name)
                    let filename = url.split("/")[8];
                    this.$set(this.filenamearr, i, filename);
                    this.ziliaoarr.push(1)
                    let houzhui = this.filenamearr[i].substring(filename.lastIndexOf(".") + 1)

                    if (houzhui == 'rar' || houzhui == 'zip') {
                      this.ziliaoarr[i] = require("../../../static/img/zip.png");
                    } else if (houzhui == 'doc' || houzhui == 'docx') {
                      this.ziliaoarr[i] = require("../../../static/img/word.png");
                    } else if (houzhui == 'xls' || houzhui == 'xlsx') {
                      this.ziliaoarr[i] = require("../../../static/img/word.png");
                    } else if (houzhui == 'ppt' || houzhui == 'pptx') {
                      this.ziliaoarr[i] = require("../../../static/img/ppt.png");
                    } else if (houzhui == 'pdf') {
                      this.ziliaoarr[i] = require("../../../static/img/pdf.jpg");
                    } else if (houzhui == 'txt') {
                      this.ziliaoarr[i] = require("../../../static/img/txt.jpg");
                    } else if (houzhui == "jpg" ||
                      houzhui == "jpeg" ||
                      houzhui == "png") {
                      this.ziliaoarr[i] = url;
                    }
                  }
                }
              } else {}
            }
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      fileloading(e, f, g, m) {
        let houzui = e.substring(e.lastIndexOf(".") + 1) //e.split(".")[3];

        if (houzui == "doc" || houzui == "docx") {

          this[g] = require("../../../static/img/word.png")
        } else if (houzui == "pptx" || houzui == "ppt") {
          this[g] = require("../../../static/img/ppt.png")
        } else if (houzui == "pdf") {
          this[g] = require("../../../static/img/pdf.jpg")
        } else if (houzui == "xls" || houzui == "xlsx") {
          this[g] = require("../../../static/img/excel.png")
        } else if (houzui == "jpg" || houzui == "jpeg" || houzui == "png") {
          this[g] = e;
        } else if (houzui == "zip" || houzui == "rar") {
          this[g] = require("../../../static/img/zip.png")
        } else if (houzui == "txt") {
          this[g] = require("../../../static/img/txt.jpg")
        }
        this[f] = e.split("/")[8];
        this[m] = e;
      },
      getSubmis() {
        this.$http({
            method: "get",
            url: "v1/test/cent-data",
            params: {
              id: this.id
            }
          })
          .then(res => {

            if (res.data.code === 200) {
              this.getsubs = res.data.data;
              let arrlist = JSON.parse(res.data.data.over.ziliao)
              if (arrlist.length) {
                if (arrlist.length < 2) {
                  this.stateing = 2
                } else {
                  this.stateing = 1
                }
                this.ziliaoarr = []
                for (let i in arrlist) {
                  let url = arrlist[i].elereport;
                  this.name[i] = arrlist[i].name;
                  this.urls[i] = arrlist[i].elereport;
                  // this.$set(this.name,i,arrlist[i].name)
                  let filename = url.split("/")[8];
                  this.$set(this.filenamearr, i, filename);
                  this.ziliaoarr.push(1)
                  let houzhui = this.filenamearr[i].substring(filename.lastIndexOf(".") + 1)

                  if (houzhui == 'rar' || houzhui == 'zip') {
                    this.ziliaoarr[i] = "/static/img/zip.png";
                  } else if (houzhui == 'doc' || houzhui == 'docx') {
                    this.ziliaoarr[i] = "/static/img/word.png";
                  } else if (houzhui == 'xls' || houzhui == 'xlsx') {
                    this.ziliaoarr[i] = "/static/img/excel.png";
                  } else if (houzhui == 'ppt' || houzhui == 'pptx') {
                    this.ziliaoarr[i] = "/static/img/ppt.png";
                  } else if (houzhui == 'pdf') {
                    this.ziliaoarr[i] = require("../../../static/img/pdf.jpg");
                  } else if (houzhui == 'txt') {
                    this.ziliaoarr[i] = "/static/img/txt.jpg";
                  } else if (houzhui == "jpg" ||
                    houzhui == "jpeg" ||
                    houzhui == "png") {
                    this.ziliaoarr[i] = url;
                  }
                }

              }
            } else {
              alert(res.data.msg);
            }
          })
          .catch(err => {
            // console.log(error);(err);
          });
      },
      postEnd(index) {
        if (index == 0) {
          this.$confirm("此操作将保存当前填写的内容, 是否继续?？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let procondition = this.stateText;
            for (let i in this.ziliaoarr) {
              this.fileurl7[i] = {
                name: "",
                elereport: ""
              };
              if (this.name[i]) {
                this.fileurl7[i].name = this.name[i];
              }
              if (this.urls[i] == "" || this.urls[i] == undefined) {
                this.$message({
                  message: '请上传活动材料文件',
                  type: "error"
                });
                return false;
              }
              if (this.urls[i]) {
                this.fileurl7[i].elereport = this.urls[i];
              }
            }
            if (this.fileurl7[0].name == "" || this.fileurl7[0].elereport == "") {
              this.$message.error("请上传末期评审参评资料");
              return false
            }
            this.$http({
                method: "post",
                url: "v1/test/end-sub",
                data: {
                  subStatus: 0,
                  project_id: this.id,
                  // explain: this.fileurl,
                  // location: this.fileurl1,
                  // assess: this.fileurl2,
                  // people: this.getpros.prodemofg,
                  // develop: this.subMidVal,
                  // pro_condition: this.stateVal,
                  // result: this.proactVal,
                  // summary: this.sumupVal,
                  // fina: this.fileurl4,
                  // elereport: this.fileurl5,
                  // adjust: this.fileurl6,
                  ziliao: JSON.stringify(this.fileurl7),
                  ppt:this.fileurl6
                  // pro_result: this.fileurl8,
                  // manage: this.fileurl9,
                  // money: this.fileurl10
                }
              })
              .then(res => {
                if (res.data.data.code == 200) {
                  this.$message({
                    message: '保存成功!',
                    type: "success"
                  });
                  this.$router.go(-1)
                } else {
                  this.$message.error(res.data.data.msg);
                }
              })
              .catch(err => {
                // console.log(error);(err);
              });
          });
        } else if (index == 1) {
          this.$confirm("请确认是否提交结项评审材料，提交后不可修改！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            let procondition = this.stateText;
            for (let i in this.ziliaoarr) {
              this.fileurl7[i] = {
                name: "",
                elereport: ""
              };
              if (this.name[i]) {
                this.fileurl7[i].name = this.name[i];
              }
              if (this.urls[i] == "" || this.urls[i] == undefined) {
                this.$message({
                  message: '请上传活动材料文件',
                  type: "error"
                });
                return false;
              }
              if (this.urls[i]) {
                this.fileurl7[i].elereport = this.urls[i];
              }
            }
            if (this.fileurl7[0].name == "" || this.fileurl7[0].elereport == "") {
              this.$message.error("请上传末期评审参评资料");
              return false
            }

            this.$http({
                method: "post",
                url: "v1/test/end-sub",
                data: {
                  subStatus: 1,
                  project_id: this.id,
                  // explain: this.fileurl,
                  // location: this.fileurl1,
                  // assess: this.fileurl2,
                  // people: this.getpros.prodemofg,
                  // develop: this.subMidVal,
                  // pro_condition: this.stateVal,
                  // result: this.proactVal,
                  // summary: this.sumupVal,
                  // fina: this.fileurl4,
                  // elereport: this.fileurl5,
                  // adjust: this.fileurl6,
                  ziliao: JSON.stringify(this.fileurl7),
                  ppt:this.fileurl6
                  // pro_result: this.fileurl8,
                  // manage: this.fileurl9,
                  // money: this.fileurl10
                }
              })
              .then(res => {
                if (res.data.data.code == 200) {
                  this.$message({
                    message: '提交成功!',
                    type: "success"
                  });
                  //
                  this.$router.go(-1)
                } else {
                  this.$message.error(res.data.data.msg);
                }
              })
              .catch(err => {
                // console.log(error);(err);
              });
          });
        }
      }
    },
    created() {
      this.id = this.$route.query.id;
      this.getPro();
      this.getSubmis()
    }
  };

</script>
<style>
  .el-picker-panel {
    z-index: 99999 !important;
    background: #fff;
  }

</style>
<style lang="scss" scoped>
  .button_add {
    height: 40px;
    margin-top: 51px;
    position: absolute;
    top: 35px;
    right: 150px;
    z-index: 999
  }

  // .upload-demo /deep/ .el-upload-list__item-status-label .el-icon-upload-success{
  //     display: none !important;

  // }

  td {
    border: 1px solid #eee !important;
  }

  #excute_box /deep/ .el-upload-list {
    // width: 82%;
    // width: 575px;/
    // margin-left: 175px;
    position: relative;
    width: 388px;
    right: 144px;
  }

  .upload-demo /deep/ .el-icon-upload-success {
    display: none !important;
    background: red;
  }

  .close {
    position: relative;
    top: -77px;
    z-index: 999;
    left: 54px;
  }

  .close2 {
    position: relative;
    top: -168px;
    z-index: 999;
    left: 110px;
  }

  .wr .close {
    position: relative;
    top: -114px;
    z-index: 999;
    left: 110px;
  }

  .tj {
    background-image: linear-gradient(69deg,
        #cc263f 0%,
        #f42b47 100%,
        #ed162d 100%,
        #e60012 100%),
      linear-gradient(#e60012, #e60012);
  }

  .fengong {
    margin-top: 30px;

    .fengongtitle {
      margin-bottom: 15px;
    }
  }

  .activebox {
    margin-bottom: 30px;
  }

  .activeup {
    margin-left: 45px;
  }

  label {
    text-align: left !important;
  }

  .rich {
    z-index: 10;
    width: 100%;
    // margin: 30px auto 0px;
    // margin-bottom: 20px;
    height: 320px;
  }

  #excute_box {
    width: 1300px;
    margin: 0 auto;
    margin-top: 40px;
    background: white;

    .excute_con {
      // min-width: 1200px;
      width: 1200px;
      margin: 0 auto;
      padding: 40px 30px;
      margin-bottom: 51px;

      h3 {
        line-height: 260%;
        font-size: 20px;
        margin: 15px 0;
        position: relative;
        right: 19px;
      }

      p a {
        line-height: 10%;
        color: #7471ef;
        font-size: 14px;
        margin-right: 10px;
      }

      label {
        margin-left: 16px;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #333333;
        text-align: right;
        display: inline-block;
        // width: 200px;
      }

      input {
        box-sizing: border-box;
        width: 33.8%;
        height: 35px;
        background-color: #ffffff;
        border: solid 1px #c7c7c7;
        outline: none;
        margin-left: 35px;
        margin-bottom: 15px;
        font-family: "MicrosoftYaHei";
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #323232;
        margin-right: 35px;
      }

      .division {
        width: 76%;
        margin-bottom: 15px;
      }

      .midsion {
        width: 80%;
        margin-left: 3px;
        margin-bottom: 10px;
      }

      span {
        font-size: 18px;
      }

      span a {
        color: #7471ef;
      }

      p {
        font-size: 14px;
        color: #666;
        line-height: 30px;
      }

      .download {
        color: #7471ef;
        padding-left: 30px;
        font-size: 14px;
      }
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      border: 1.5px dashed #666;
    }

    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }

    .mid_box span {
      font-size: 14px;
    }

    .ll {
      margin-top: 80px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      button[type="button"] {
        margin-right: 152px;
        width: 197px;
        height: 63px;
        background-color: #ff9800;
        border-radius: 5px;
        font-family: "MicrosoftYaHei";
        font-size: 26px;
        font-weight: 400;
        font-stretch: normal;
        // line-height: 63px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        outline: none;
        border: 0;
      }

      button[type="submit"] {
        width: 197px;
        height: 63px;
        background-color: #e60012;
        border-radius: 5px;
        font-family: "MicrosoftYaHei";
        font-size: 26px;
        font-weight: normal;
        font-stretch: normal;
        // line-height: 63px;
        text-align: center;
        letter-spacing: 0px;
        color: #ffffff;
        outline: none;
        border: 0;
      }
    }

    .excute_tab {
      clear: both;
      width: 90%;
      margin: 0;
      padding: 40px 0;
      // border: 1px solid green;
    }

    .caption {
      width: 81%;
      height: 38px;
      border-bottom: 1px solid #dedede;
      // margin-top: 76px;
      margin-bottom: 30px;
      padding-left: 30px;
      box-sizing: border-box;
      position: relative;

      span {
        display: inline-block;
        height: 38px;
        text-align: center;
        font-family: "MicrosoftYaHei";
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        margin-right: 49px;
      }

      span.active {
        border-bottom: 2px solid #7471ef;
      }

      .speed_box {
        position: absolute;
        right: 10px;
        top: 10px;
      }

      .speed_box a {
        color: #7471ef;
        font-size: 16px;
        padding-left: 20px;
      }
    }

    .statistics {
      td {
        border: 1px solid #eee !important;
        // border: none !important;
      }
    }

    th {
      line-height: 40px;
      text-align: center;
      height: 40px;
      font-family: "MicrosoftYaHei";
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      // color: #666666;
      background-color: rgba(247, 247, 247, 1);
      box-sizing: border-box;
      background-color: #a3a3a3;

      &:nth-of-type(1) {
        width: 200px;
      }

      &:nth-of-type(2) {
        width: 250px;
      }

      &:nth-of-type(3) {
        width: 200px;
      }

      &:nth-of-type(4) {
        width: 200px;
      }

      &:nth-of-type(5) {
        width: 180px;
      }
    }

    .on {
      background-color: #fff;
    }

    .on td {
      padding: 10px 0;
    }

    .td_tooltip {
      border-bottom: 1px solid #eee;
    }

    .off {
      background-color: #f7f7f7;
    }

    .off td {
      padding: 10px 0;
    }
  }

</style>
